module.exports = __webpack_public_path__ + "img/style_3_6.4313308d.png";